import { render, staticRenderFns } from "./formTemplates.vue?vue&type=template&id=40b70779&scoped=true"
import script from "./formTemplates.vue?vue&type=script&lang=js"
export * from "./formTemplates.vue?vue&type=script&lang=js"
import style0 from "./formTemplates.vue?vue&type=style&index=0&id=40b70779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b70779",
  null
  
)

export default component.exports